<div class="relative" *transloco="let t">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<h1 class="cursor-move" mat-dialog-title cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
		{{ title() }}
	</h1>
	<mat-dialog-content>
		@if (showPermissionTypeSelect()) {
			<mat-form-field [ngClass]="!isMobile() ? 'mb-4' : 'mb-1'" appearance="fill" class="w-full">
				<mat-label>{{ t('permissions.type') }}</mat-label>
				<mat-select [formControl]="permissionTypeFC">
					@for (permissionType of permissionTypes; track permissionType) {
						<mat-option [value]="permissionType">
							{{ t('permissions.typeEnum.' + permissionType) }}
						</mat-option>
					}
				</mat-select>
				<mat-error>
					{{ t('common.requiredField') }}
				</mat-error>
			</mat-form-field>
		}
		@if (permission.authCode) {
			<mat-form-field [ngClass]="!isMobile() ? 'mb-4' : 'mb-1'" appearance="fill" class="w-full">
				<mat-label>{{ t('user.code') }}</mat-label>
				<div class="flex items-center justify-between">
					@if (!hasHiddenCode()) {
						<input [(ngModel)]="permission.authCode" disabled matInput />
					} @else {
						<button (click)="removeCode()" [disabled]="hasHiddenCode()" mat-icon-button title="{{ t('user.deleteCode') }}">
							<mat-icon [svgIcon]="icons.get('delete')"></mat-icon>
						</button>
						<input disabled matInput />
					}
				</div>
			</mat-form-field>
		}
		@if (!isEdit()) {
			<div class="flex flex-wrap items-center justify-between gap-2" [ngClass]="!isMobile() ? 'mb-4' : 'mb-1'">
				<mat-checkbox (change)="resetMailValidator()" [(ngModel)]="sendMail">
					{{ t('tenantunitDetails.sendMail') }}
				</mat-checkbox>
				@if (hasPersonEmail()) {
					<button
						type="button"
						mat-button
						class="inline-flex min-w-0 max-w-full items-center gap-0.5 px-1"
						(click)="copyPersonEmail()"
						title="{{ t('permissions.copyEmail') }}">
						<mat-icon class="mr-0">content_copy</mat-icon>
						<span class="max-w-[260px] overflow-hidden text-ellipsis whitespace-nowrap font-medium text-gray-700">{{ getPersonEmail() }}</span>
					</button>
				}
			</div>
			<mat-form-field [ngClass]="!isMobile() ? 'mb-4' : 'mb-1'" appearance="fill" class="w-full">
				<mat-label>{{ t('user.email') }}</mat-label>
				<input
					(change)="trimMail()"
					[(ngModel)]="permission.email"
					[formControl]="mailLengthFC"
					[required]="sendMail()"
					matInput
					placeholder="{{ t('user.email') }}" />
				<mat-error>
					{{ t('common.requiredField') }}
				</mat-error>
			</mat-form-field>
		}
		<mat-form-field [ngClass]="!isMobile() ? 'mb-4' : 'mb-1'" appearance="fill" class="w-full">
			<mat-label>{{ t('common.comment') }}</mat-label>
			<textarea [(ngModel)]="permission.comment" (ngModelChange)="commentChange()" matInput [placeholder]="t('common.comment')"></textarea>
		</mat-form-field>
	</mat-dialog-content>
	<mat-dialog-actions class="flex items-center justify-end" mat-dialog-actions>
		<button (click)="close(true)" [disabled]="!isEdited() && isEdit()" class="save-button m-2" color="primary" mat-raised-button>
			<mat-icon>save</mat-icon>
			@if (!isMobile()) {
				<span>
					{{ t('commonActions.save') }}
				</span>
			}
		</button>
	</mat-dialog-actions>
</div>
